









import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';
import { SEARCH_GETTERS_KEYS } from '../../store/search/search.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components
    }),
    ...mapGetters(SUBMODULES_PATHS.search, {
      renderNoResults: SEARCH_GETTERS_KEYS.showNoResults
    }),
    ...mapState(SUBMODULES_PATHS.search, ['query'])
  }
})
export default class NoResults extends Vue {
}
